<template>
  <div
    v-editable="blok"
    class="ImageGalleryBlock desktopMaxW-full"
    :class="desktopWidth('md')"
  >
    <div v-if="blok.images.length > 1" class="relative">
      <client-only>
        <Swiper
          class="swiper-cover desk:!overflow-hidden !overflow-visible w-full desk:!pb-40 !pb-32"
          :modules="[SwiperNavigation, SwiperPagination, SwiperA11y]"
          :space-between="uiStore.isMobile ? 8 : 12"
          :pagination="{
            clickable: true,
            dynamicBullets: true,
          }"
          :navigation="{
            nextEl: `.swiper-button-next.swiper-for-blok-${blok._uid}`,
            prevEl: `.swiper-button-prev.swiper-for-blok-${blok._uid}`,
          }"

          :loop="false"
          :slides-per-view="uiStore.isMobile ? 1.1 : 1"
          :no-swiping="true"
        >
          <SwiperSlide
            v-for="image in blok.images"
            :key="image.id"
            class="deskLarge:!overflow-hidden desk:cursor-grab desk:active:cursor-grabbing"
          >
            <div
              :class="{
                'aspect-landscape' : blok.aspectRatio === 'aspect-landscape',
                'aspect-wide' : blok.aspectRatio === 'aspect-wide',
              }"
            >
              <nuxt-img
                preset="standard"
                loading="lazy"
                sizes="sm:100vw desk:1260px"
                class="h-full w-full object-cover"
                :src="image.filename"
                :alt="image.alt"
              />
            </div>
            <div
              v-if="blok.displayCaption"
              class="px-12 pt-12 type-xxs desk:type-xs block text-dark"
            >
              {{ image.name }}
            </div>
          </SwiperSlide>
        </Swiper>
        <div class="hidden desk:block">
          <div
            class="swiper-button-prev"
            :class="{[`swiper-for-blok-${blok._uid}`]: true}"
          />
          <div
            class="swiper-button-next"
            :class="{[`swiper-for-blok-${blok._uid}`]: true}"
          />
        </div>
      </client-only>
    </div>

    <div
      v-for="image in blok.images"
      v-else
      :key="image.id"
    >
      <div
        :class="{
          'aspect-landscape' : blok.aspectRatio === 'aspect-landscape',
          'aspect-wide' : blok.aspectRatio === 'aspect-wide',
        }"
      >
        <nuxt-img
          preset="standard"
          loading="lazy"
          sizes="sm:100vw desk:1260px"
          class="h-full w-full object-cover"
          :src="image.filename"
          :alt="image.alt"
        />
      </div>
      <div
        v-if="blok.displayCaption"
        class="px-12 pt-12 type-xxs desk:type-xs block text-dark"
      >
        {{ image.name }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  StoryBlokPropBase,
  StoryBlokAsset
} from '~/constants/types/storyblok';

import { useUiStore } from '~/store/ui';

import useDesktopWidth from '~/composeables/useDesktopWidth';

const uiStore = useUiStore();

type Props = StoryBlokPropBase & {
  images: StoryBlokAsset[];
  displayCaption: boolean;
  aspectRatio: 'aspect-landscape' | 'aspect-wide',
}

const props = defineProps<{
  blok: Props,
}>();

const { desktopWidth } = useDesktopWidth(props);

</script>
<style lang="postcss">

  .priceLoadBox {
    color: rgba(0,0,0,0);
    animation-name: spin;
    animation-duration: 1000ms;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
    animation-direction: alternate;
  }

  @keyframes spin {
    from {
      background-color: #DEDDD9;
    }
    to {
      background-color: #F5F4F0;
    }
  }
</style>
